import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
// import imgLogo from "../../../../../image/logo.png"
import axios from "../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import { GetToken } from "../../../../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
// import "./CreateArticle.css"
import "./style.css";

// components
import FormField from "../../Components/FormField/FormField";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button, CardActionArea } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
export default function CreateArticle() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [subject_name, setsubject_name] = useState("");
  const [subjectlist, setsubjectlist] = useState([]);

  const handelsubmit = () => {
    if (!subject_name) {
      return;
    }
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    axios.post("/admin/createsubject", { subject_name }, config).then((e) => {
      // setsubject_name(subject_name);
      if (e.data.error) {
        return swal({
          title: "Error",
          text: "This Subject is already exist",
          icon: "error",
        });
      }

      setsubjectlist([...subjectlist, { subject_name: subject_name }]);
      setsubject_name("");
    });
  };
  const getSubject = () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    axios.get("/admin/getsubject", config).then((e) => {
      setsubjectlist(e.data.Subject);
    });
  };
  const deleteSubject = (e) => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const find = subjectlist.filter((es) => {
      return es !== e;
    });
    setsubjectlist(find);

    axios
      .delete(`/admin/deletesubject/${e._id.toString()}`, config)
      .then((e) => {
        // setsubjectlist(e.data.Subject);
      });
  };

  const handleInputChange = (e) => {
    setsubject_name(e.target.value);
  };
  useEffect(() => {
    getSubject();
    return () => {};
  }, []);

  return (
    <>
      <div style={{ flex: 4 }}>
        <form action="" className="admin__userUpdateForm">
          <div className="userUpdateLeft">
            <h5>Create Subject</h5>
            <FormField
              type="text"
              label="Subject Name"
              placeholder="Title"
              value={subject_name}
              name="title"
              handleChange={handleInputChange}
            />
            <br />
            <Button
              className="create_user_btn"
              variant="contained"
              // style={{ margin: "20px" }}
              onClick={handelsubmit}
            >
              Add Subject
            </Button>
          </div>
        </form>{" "}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            paddingLeft: "170px",
            paddingRight: "170px",
          }}
        >
          {subjectlist.map((e, i) => {
            return (
              <Card key={i} sx={{ width: 250, marginX: 1, marginY: 2 }}>
                {/* <CardActionArea> */}
                <CardContent
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography gutterBottom variant="h6" component="div">
                    {e.subject_name}
                  </Typography>
                  <button style={{ border: "none", background: "none" }}>
                    <DeleteIcon
                      onClick={() => {
                        deleteSubject(e);
                      }}
                      sx={{ justifyContent: "flex-end" }}
                    />
                  </button>
                  {/* {DeleteIcon} */}
                </CardContent>
                {/* </CardActionArea> */}
              </Card>
            );
          })}
        </div>
      </div>
    </>
  );
}
